import styles from "./home.module.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";
import CorporateLanding from "../../templates/CorporateLanding";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Loader from "../../../admin/components/Loader";
import CourierDeliveryTemplate from "../../templates/CourierDelivery";
import ModernMinimalTemplate from "../../templates/ModernMinimalTemplate";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";

const customerSlider = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

// Steps shown in the numbered "how it works" list on the banner
const bannerSteps = [
  "Choose a suitable template",
  "Add your logo, colours and business details",
  "Customers book and track orders live",
  "Drivers manage pickups from their app",
  "Warehouse teams scan and validate items",
  "Super admins control operations and reports",
];

const Home = () => {
  const navigate = useNavigate();
  const { websiteData, loading } = useWebsite();

  useSiteBranding("Home", websiteData);

  if (websiteData && websiteData?.website_template_id) {
    if (websiteData?.website_template_id === 1 && websiteData?.home_config) {
      return <CorporateLanding data={websiteData?.home_config} isStickyHeader={true} />
    }
    if (websiteData?.website_template_id === 2 && websiteData?.home_config) {
      return <CourierDeliveryTemplate data={websiteData?.home_config} isStickyHeader={true} />
    }
    if (websiteData?.website_template_id === 3 && websiteData?.home_config) {
      return <ModernMinimalTemplate data={websiteData?.home_config} isStickyHeader={true} />
    }
  }

  return (<>
    <Loader open={loading} />

    <Header />

    <div className={`${styles.mainDiv}`}>
      <div className={`${styles.BannerSec} ${styles.HomeBannerSec}`}>
        <div className={`${styles.Banner}`}>
          <img src="/images/ef-logistics-banner-new2.png" className={`${styles.BannerBG}`} alt="EF Logistics driver loading a delivery van" />
          <div className={`${styles.Container}`}>
            <div className={`${styles.BannerContent}`}>
              <div className={`${styles.BannerText}`}>
                <div className={`${styles.BannerCopy}`}>
                  <p className={`${styles.BannerTitle} ${styles.Heading}`}>Own Your Logistics Platform End to End</p>
                  <p className={`${styles.BannerTagline}`}>Your Brand. Your Customers. Your Control.</p>

                  <div className={`${styles.BannerFeatureCard}`}>
                    <h3>A Complete Door-to-Door Operating System</h3>
                    <p className={`${styles.BannerFeatureTags}`}>
                      Bookings&nbsp;&bull;&nbsp;Tracking&nbsp;&bull;&nbsp;Drivers&nbsp;&bull;&nbsp;Warehouse&nbsp;&bull;&nbsp;Payments&nbsp;&bull;&nbsp;Reports
                    </p>
                    <p className={`${styles.BannerFeatureDesc}`}>Launch faster with technology designed for modern logistics businesses.</p>
                  </div>

                  <button className={`${styles.HomeBU}`} onClick={(e) => navigate("/sign-up")}>Start Your EF Logistics Platform Today</button>
                </div>

                <ol className={`${styles.BannerSteps}`}>
                  {bannerSteps.map((step, index) => (
                    <li key={step}>
                      <span className={`${styles.BannerStepNumber}`}>{String(index + 1).padStart(2, "0")}</span>
                      <span className={`${styles.BannerStepText}`}>{step}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.FeatresSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.FeaturesSecHeading} ${styles.BodySecHeading}`}>Built for Reliable</h3>
          <p className={`${styles.FeaturesSecSubHeading} ${styles.BodySecSubHeading}`}>Deliveries<span></span></p>
        </div>
        <div className={`${styles.FeatresSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image1.jpg" alt="" />
            </div>
            <div className={`${styles.FeatresSecContainerItemBody}`}>
              <h2 className={`${styles.FeatresSecContainerItemHeading}`}>Real-time tracking</h2>
              <p className={`${styles.FeatresSecContainerItemDesc}`}>Give customers a live map view of every
                shipment, from pickup to final
                delivery.<span>Read More</span></p>
            </div>
          </div>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image2.jpg" alt="" />
            </div>
            <div className={`${styles.FeatresSecContainerItemBody}`}>
              <h2 className={`${styles.FeatresSecContainerItemHeading}`}>Automated scheduling</h2>
              <p className={`${styles.FeatresSecContainerItemDesc}`}>Assign pickups and routes automatically
                so drivers spend less time waiting
                and more time delivering.<span>Read More</span></p>
            </div>
          </div>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image3.jpg" alt="" />
            </div>
            <div className={`${styles.FeatresSecContainerItemBody}`}>
              <h2 className={`${styles.FeatresSecContainerItemHeading}`}>End-to-end supply chain visibility</h2>
              <p className={`${styles.FeatresSecContainerItemDesc}`}>Follow every parcel through warehouse,
                transit and delivery from a single
                dashboard.<span>Read More</span></p>
            </div>
          </div>
          <div className={`${styles.FeatresSecContainerItem}`}>
            <div className={`${styles.FeatresSecContainerItemImageDiv}`}>
              <img src="/images/featureSec_image4.jpg" alt="" />
            </div>
            <div className={`${styles.FeatresSecContainerItemBody}`}>
              <h2 className={`${styles.FeatresSecContainerItemHeading}`}>Seamless integration with your operations</h2>
              <p className={`${styles.FeatresSecContainerItemDesc}`}>Connect bookings, invoicing and reporting
                to the tools your team already
                uses.<span>Read More</span></p>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.TaskFlowSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.TaskFlowSecHeading} ${styles.BodySecHeading}`}>Start Using Your Platform</h3>
          <p className={`${styles.TaskFlowSecSubHeading} ${styles.BodySecSubHeading}`}>3 Simple Steps<span></span></p>
        </div>
        <div className={`${styles.TaskFlowSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>
          <div className={`${styles.TaskFlowSecContainerItem}`}>
            <span className={`${styles.TaskFlowStepIndex}`}>01</span>
            <img src="/images/signupTaskIcon.png" alt="" />
            <h2 className={`${styles.TaskFlowSecContainerItemHeading}`}>Register your business</h2>
            <p className={`${styles.TaskFlowSecContainerItemDesc}`}>Create your account in minutes and get a fully branded booking platform live the same day.</p>
          </div>
          <div className={`${styles.TaskFlowSecContainerItem}`}>
            <span className={`${styles.TaskFlowStepIndex}`}>02</span>
            <img src="/images/setupTaskIcon.png" alt="" />
            <h2 className={`${styles.TaskFlowSecContainerItemHeading}`}>Schedule your customers pickup</h2>
            <p className={`${styles.TaskFlowSecContainerItemDesc}`}>Customers book pickups online and get live status updates from collection through to delivery.</p>
          </div>
          <div className={`${styles.TaskFlowSecContainerItem}`}>
            <span className={`${styles.TaskFlowStepIndex}`}>03</span>
            <img src="/images/trackTaskIcon.png" alt="" />
            <h2 className={`${styles.TaskFlowSecContainerItemHeading}`}>Get your pickup and delivery app</h2>
            <p className={`${styles.TaskFlowSecContainerItemDesc}`}>Equip drivers and warehouse teams with dedicated apps for routing, scanning and proof of delivery.</p>
          </div>
        </div>
      </div>
      <div className={`${styles.CustomerSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.CustomerSecHeading} ${styles.BodySecHeading}`}>What Our Customers Are </h3>
          <p className={`${styles.CustomerSecSubHeading} ${styles.BodySecSubHeading}`}>Saying<span></span></p>
        </div>
        <div className={`${styles.Container}`}>
          <Carousel
            responsive={customerSlider}
            className={`${styles.customerSlider}`}
            swipeable={true}
            arrows={false}
            draggable={true}
            showDots={true}
            ssr={true}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={6000}
            keyBoardControl={true}
            customTransition="600ms all"
            transitionDuration={600}
          >
            <div className={`${styles.item}`}>
              <div className={`${styles.CustomerImageDiv}`}>
                <img src="/images/testimonial.png" alt="" />
              </div>
              <div className={`${styles.CustomerContentDiv}`}>
                <p className={`${styles.CustomerDesc}`}>EF Logistics has completely streamlined our workflow. It's easy to use,
                  and our team's productivity has increased dramatically.</p>
                <p className={`${styles.CustomerDesignation}`}>Marketing Manager</p>
                <p className={`${styles.CustomerName}`}>Lucy H</p>
              </div>
            </div>
            <div className={`${styles.item}`}>
              <div className={`${styles.CustomerImageDiv}`}>
                <img src="/images/testimonial.png" alt="" />
              </div>
              <div className={`${styles.CustomerContentDiv}`}>
                <p className={`${styles.CustomerDesc}`}>Great tool for remote teams. We stay in sync and never miss a delivery deadline.</p>
                <p className={`${styles.CustomerDesignation}`}>Operations Director</p>
                <p className={`${styles.CustomerName}`}>Chris M</p>
              </div>
            </div>

            <div className={`${styles.item}`}>
              <div className={`${styles.CustomerImageDiv}`}>
                <img src="/images/testimonial.png" alt="" />
              </div>
              <div className={`${styles.CustomerContentDiv}`}>
                <p className={`${styles.CustomerDesc}`}>The tracking and warehouse features are fantastic. We can now see exactly where
                  every shipment stands at any moment.</p>
                <p className={`${styles.CustomerDesignation}`}>Product Owner</p>
                <p className={`${styles.CustomerName}`}>James B</p>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
      <div className={`${styles.PlanSec}`}>
        <div className={`${styles.Container} ${styles.SecHeadingContainer}`}>
          <h3 className={`${styles.PlanSecHeading} ${styles.BodySecHeading}`}>Affordable Plans for Every</h3>
          <p className={`${styles.PlanSecSubHeading} ${styles.BodySecSubHeading}`}>Team<span></span></p>
        </div>
        <div className={`${styles.PlanSecContainer} ${styles.Container} ${styles.FeatresPosition}`}>

          <div className={`${styles.PlanSecContainerItem}`}>
            <span className={`${styles.PlanBadge} ${styles.PlanBadgeFree}`}>7-day trial</span>
            <img src="/images/freePlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Free Trial</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>Try the platform with bookings, customers, item tracking and the customer portal.</p>
            <p className={`${styles.planPriceText}`}>Price: <span>Free for 7 days</span></p>
            <button className={`${styles.eachPlanButton}`} onClick={(e) => navigate("/sign-up")}>Start free trial</button>
          </div>

          <div className={`${styles.PlanSecContainerItem}`}>
            <img src="/images/proPlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Standard</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>Bookings, customers, item tracking and the customer portal for growing teams.</p>
            <p className={`${styles.planPriceText}`}>Price: <span>£350/month</span></p>
            <button className={`${styles.eachPlanButton}`} onClick={(e) => navigate("/sign-up")}>Get started</button>
          </div>

          <div className={`${styles.PlanSecContainerItem} ${styles.PlanSecContainerItemPopular}`}>
            <span className={`${styles.PlanBadge}`}>Most popular</span>
            <img src="/images/enterprisePlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Premium</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>Everything in Standard, plus driver management, shipping & delivery, and dedicated apps.</p>
            <p className={`${styles.planPriceText}`}>Price: <span>£513/month</span></p>
            <button className={`${styles.eachPlanButton}`} onClick={(e) => navigate("/sign-up")}>Get started</button>
          </div>

          <div className={`${styles.PlanSecContainerItem}`}>
            <img src="/images/enterprisePlanIcon.png" alt="" />
            <h2 className={`${styles.PlanSecContainerItemHeading}`}>Full</h2>
            <p className={`${styles.PlanSecContainerItemDesc}`}>Everything in Premium, plus the referral system, membership benefits and 24/7 support.</p>
            <p className={`${styles.planPriceText}`}>Price: <span>£2,518/month</span></p>
            <button className={`${styles.eachPlanButton}`} onClick={(e) => navigate("/sign-up")}>Get started</button>
          </div>

        </div>
      </div>
    </div>

    <Footer />
  </>);
};

export default Home;
